








import Vue from 'vue'
import Component from 'vue-class-component'
import { multiplyKey } from './custom-flows'

// The @Component decorator indicates the class is a Vue component
@Component({})
export default class RedFlow extends Vue {
  another(): void {
    this.$flows.start(multiplyKey)
  }
  cancel(): void {
    this.$emit('close-flow')
  }
}
